<template lang="pug">
  modal(:closeButton='closeButton' @closeModal='hideElement(doneModal)')
    .image-container.column.center.middle(:class='backgroundClass')
      h2.title-big
        | {{ storeProps.message }}
</template>

<script>
import { mapState, mapActions } from 'vuex'

import Modal from '../Modal'

export default {
  data() {
    return {
      doneModal: {
        element: 'doneModal'
      }
    }
  },
  props: {
    message: { type: String, required: false, default: '¡Gracias!' }, // This isn't needed if we use props from the store because the restrictions won't apply.
    background: { type: String, required: false },
    closeButton: { type: Boolean, required: false, default: true }
  },
  methods: {
    ...mapActions([
      'hideElement'
    ])
  },
  computed: {
    ...mapState({
      storeProps: state => state.behavior.doneModal.props
    }),
    backgroundClass() {
      return this.storeProps.background
    }
  },
  components: { Modal }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';

.image-container {
  height: 100%;
  min-height: 230px;
  max-height: 325px;
  width: 100%;

  &.share-resource {
    background: $white url('../../assets/il_thanks.svg') no-repeat center;
  }

  .text-container {
    height: 100%;
  }
}
</style>
